import {SpanIcon} from '@mazraeapp/react_icon_kit';
import React from 'react';
interface StepOneProps {
  price: number;
  setStepChoosed: React.Dispatch<React.SetStateAction<string>>;
}
const StepOne = ({price, setStepChoosed}: StepOneProps) => {
  return (
    <div className="flex justify-between  w-full ">
      <p className="flex w-[30%] justify-between pb-0 mb-0 items-center text-sm font-Medium px-2 gap-1">
        <span className="whitespace-nowrap">مبلغ کل:</span>
        <div className="flex items-center gap-1">
          <span>{price.toLocaleString()}</span>
          <span className="text-xs font-Regular">تومان</span>
        </div>
      </p>
      <button
        className="bg-farm-shop-500 h-[40px] px-2 rounded-[8px] w-[50%] flex items-center justify-center text-white text-sm font-Medium"
        onClick={() => setStepChoosed('stepTwo')}
      >
        <SpanIcon className="" />
        <span> صورتحساب و پرداخت</span>
      </button>
    </div>
  );
};

export default StepOne;
